import Phaser from 'phaser';
import { PICKUP_TEXTURES } from '../systems/PlaceholderTextures.js';

const GLYPHS = {
  heart: '+',
  gem: '*',
  speed: '>',
  shield: 'S',
  doubleDmg: 'X2',
};

export class Pickup extends Phaser.Physics.Arcade.Sprite {
  constructor(scene, x, y, type) {
    const tex = PICKUP_TEXTURES[type] || 'pickup-gem';
    super(scene, x, y, tex);
    scene.add.existing(this);
    scene.physics.add.existing(this);
    this.pickupType = type;
    this.body.setCircle(11);

    this.glyph = scene.add
      .text(x, y, GLYPHS[type] || '?', {
        fontFamily: '"Press Start 2P", monospace',
        fontSize: '9px',
        color: '#0f0d2c',
      })
      .setOrigin(0.5)
      .setDepth(this.depth + 1);

    this.bobTween = scene.tweens.add({
      targets: this,
      y: y - 4,
      duration: 700,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut',
    });
    this.scaleTween = scene.tweens.add({
      targets: this,
      scale: 1.15,
      duration: 700,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut',
    });

    this.expiresAt = scene.time.now + 12000;
    scene.time.delayedCall(12000, () => {
      if (this.active) this.destroy();
    });
  }

  preUpdate(time, delta) {
    super.preUpdate(time, delta);
    this.glyph.setPosition(this.x, this.y);
    // Blink toward end of life
    const remaining = this.expiresAt - time;
    if (remaining < 3000) {
      this.alpha = Math.floor(time / 120) % 2 ? 1 : 0.4;
      this.glyph.setAlpha(this.alpha);
    }
  }

  destroy(fromScene) {
    if (this.glyph) this.glyph.destroy();
    if (this.bobTween) this.bobTween.stop();
    if (this.scaleTween) this.scaleTween.stop();
    super.destroy(fromScene);
  }
}
